import angular from 'angular';
import Raven from 'raven-js';
import RavenAngular from 'raven-js/plugins/angular';

import 'angular-route';
import 'angular-resource';
import '../style/core.scss';

Raven.config("https://054483d4be4d40c58eac08dc4805bbf7@sentry.io/164661", {
    ignoreUrls: [
        /^http:\/\/localhost/,
        /fingerprint2.min.js$/,
        /^https:\/\/maps\.googleapis.com/, // PAYL-9655
    ]
}).addPlugin(RavenAngular).install();

angular.module("core.application.main", [
    "ngRaven",
    "ngRoute",
    "ngResource",
    // don't include pages and modules directly in here.
    // the importing code should opt in to the specific pages and modules it wants
]).config(["$resourceProvider", function ($resourceProvider) {
  // add `put` method to all resources by default
  $resourceProvider.defaults.actions.put = {
    method: "PUT"
  };
}
]).config(["$locationProvider", function($locationProvider) {
  // make sure the hashbangs (#) are removed from urls
  $locationProvider.html5Mode(true);
}
]);
